let appUrls = {
    api: '',
    mycompass: '',
    admin: '',
    pdf: '',
};

switch (window.location.hostname) {
    case 'localhost' || '127.0.0.1':
        // this is the local host name of the API
        appUrls.api = 'http://localhost:3252';
        appUrls.mycompass = 'http://localhost:8080';
        appUrls.admin = 'http://localhost:8081';
        appUrls.pdf = 'http://localhost:3520';
    break;
    case 'admindev.successionrg.com' || 'mystifying-chandrasekhar-8f71f3.netlify.app':
        // this is the full url of the deployed dev API
        appUrls.api = 'https://srg-api-dev.herokuapp.com';
        appUrls.mycompass = 'https://clientsdev.successionrg.com';
        appUrls.admin = 'https://admindev.successionrg.com';
        appUrls.pdf = 'https://pdf-gen-dev.herokuapp.com';
    break;
    case 'admin.successionresource.com' || 'brave-ardinghelli-8a1706.netlify.app':
        // this is the full url of the deployed live API
        appUrls.api = 'https://srg-api-prd.herokuapp.com';
        appUrls.mycompass = 'https://mycompass.successionresource.com';
        appUrls.admin = 'https://admin.successionresource.com';
        appUrls.pdf = 'https://pdf-gen-prd.herokuapp.com';
    break;
}

export default appUrls;


// WEBPACK FOOTER //
// ./src/helpers/environment.js